import { getAttrValue, isPlainObject, getLocalizedValue, isArray } from '@grandvisionhq/utils';

const getLocalizedAttributes = (variant, attrName, locale)=>{
    const attrValues = getAttrValue(variant, attrName);
    if (isPlainObject(attrValues)) {
        return [
            getLocalizedValue(attrValues, locale)
        ];
    }
    if (isArray(attrValues)) {
        return attrValues.map((attrValue)=>{
            return getLocalizedValue(attrValue, locale);
        });
    }
    return [];
};

export { getLocalizedAttributes };
//# sourceMappingURL=get-line-item-localized-attributes.js.map
